module.exports = __webpack_public_path__ + "media/Ascariasis.24a14ea7.mp4";